import React from 'react';
import { useCallback } from 'react';
import { Box, Flex, Select, FormLabel, Tooltip } from '@chakra-ui/react';
import _ from 'lodash';
import { updateComponent } from '../../redux/pagesSlice';
import { selectComponent, selectedComponent } from '../../redux/selectedComponentSlice';
import { selectedPage } from '../../redux/selectedPageSlice';
import { useDispatch, useSelector } from 'react-redux';
import { findCompByIdRecursively } from '../../utils/functions';
import { UilQuestionCircle } from '@iconscout/react-unicons';
import { defaultCategory, defaultCustom } from '../../vtex-apps/menu/MenuItem/default';

const dropdownValues = {
	colSizing: [
		{ name: 'Igual', value: 'equal' },
		{ name: 'Auto', value: 'auto' },
	],
	textPosition: [
		{
			name: 'Esquerda',
			value: 'LEFT',
		},
		{
			name: 'Centro',
			value: 'CENTER',
		},
		{
			name: 'Direita',
			value: 'RIGHT',
		},
	],
	textAlignment: [
		{
			name: 'Esquerda',
			value: 'LEFT',
		},
		{
			name: 'Centro',
			value: 'CENTER',
		},
		{
			name: 'Direita',
			value: 'RIGHT',
		},
	],
	autocompleteAlignment: [
		{
			name: 'Esquerda',
			value: 'LEFT',
		},
		{
			name: 'Centro',
			value: 'CENTER',
		},
		{
			name: 'Direita',
			value: 'RIGHT',
		},
	],
	variation: [
		{
			name: 'popup',
			value: 'popup',
		},
		{
			name: 'drawer',
			value: 'drawer',
		},
		{
			name: 'link',
			value: 'link',
		},
		{
			name: 'popupWithLink',
			value: 'popupWithLink',
		},
		{
			name: 'block',
			value: 'block',
		},
	],
	drawerSlideDirection: [
		{
			name: 'rightToLeft',
			value: 'rightToLeft',
		},
		{
			name: 'leftToRight',
			value: 'leftToRight',
		},
	],
	quantityDisplay: [
		{
			name: 'always',
			value: 'always',
		},
		{
			name: 'not-empty',
			value: 'not-empty',
		},
		{
			name: 'never',
			value: 'never',
		},
	],
	itemCountMode: [
		{
			name: 'total',
			value: 'total',
		},
		{
			name: 'distinct',
			value: 'distinct',
		},
		{
			name: 'totalAvailable',
			value: 'totalAvailable',
		},
		{
			name: 'distinctAvailable',
			value: 'distinctAvailable',
		},
	],
	backdropMode: [
		{
			name: 'drawer',
			value: 'drawer',
		},
		{
			name: 'visible',
			value: 'visible',
		},
		{
			name: 'none',
			value: 'none',
		},
	],
	orientation: [
		{
			name: 'vertical',
			value: 'vertical',
		},
		{
			name: 'horizontal',
			value: 'horizontal',
		},
	],
	onMountBehavior: [
		{
			name: 'open',
			value: 'open',
		},
		{
			name: 'closed',
			value: 'closed',
		},
	],
	onClickEventPropagation: [
		{
			name: 'enabled',
			value: 'enabled',
		},
		{
			name: 'disabled',
			value: 'disabled',
		},
	],
	size: [
		{
			name: 'small',
			value: 'small',
		},
		{
			name: 'regular',
			value: 'regular',
		},
		{
			name: 'large',
			value: 'large',
		},
	],
	selectorType: [
		{
			name: 'stepper',
			value: 'stepper',
		},
		{
			name: 'dropdown',
			value: 'dropdown',
		},
	],
	quantitySelectorStep: [
		{
			name: 'singleUnit',
			value: 'singleUnit',
		},
		{
			name: 'unitMultplier',
			value: 'unitMultplier',
		},
	],
	onClickBehavior: [
		{
			name: 'go-to-product-page',
			value: 'go-to-product-page',
		},
		{
			name: 'add-to-cart',
			value: 'add-to-cart',
		},
		{
			name: 'ensure-sku-selection',
			value: 'ensure-sku-selection',
		},
	],
	display: [
		{
			name: 'Button',
			value: 'button',
		},
		{
			name: 'Caret',
			value: 'caret-icon',
		},
	],
	displayMode: [
		{
			name: 'clear-button',
			value: 'clear-button',
		},
		{
			name: 'search-and-clear-buttons',
			value: 'search-and-clear-buttons',
		},
		{
			name: 'search-button',
			value: 'search-button',
		},
	],
	inputType: [
		{
			name: 'text',
			value: 'text',
		},
		{
			name: 'search',
			value: 'search',
		},
	],
	contentOrder: [
		{
			name: 'videos-first',
			value: 'videos-first',
		},
		{
			name: 'images-first',
			value: 'images-first',
		},
	],
	position: [
		{
			name: 'left',
			value: 'left',
		},
		{
			name: 'right',
			value: 'right',
		},
	],
	thumbnailVisibility: [
		{
			name: 'visible',
			value: 'visible',
		},
		{
			name: 'hidden',
			value: 'hidden',
		},
	],
	thumbnailsOrientation: [
		{
			name: 'vertical',
			value: 'vertical',
		},
		{
			name: 'horizontal',
			value: 'horizontal',
		},
	],
	zoomMode: [
		{
			name: 'disabled',
			value: 'disabled',
		},
		{
			name: 'in-place-click',
			value: 'in-place-click',
		},
		{
			name: 'in-place-hover',
			value: 'in-place-hover',
		},
		{
			name: 'open-modal',
			value: 'open-modal',
		},
	],
	contentType: [
		{
			name: 'images',
			value: 'images',
		},
		{
			name: 'videos',
			value: 'videos',
		},
		{
			name: 'all',
			value: 'all',
		},
	],
	slideDirection: [
		{
			name: 'horizontal',
			value: 'horizontal',
		},
		{
			name: 'vertical',
			value: 'vertical',
		},
		{
			name: 'rightToLeft',
			value: 'rightToLeft',
		},
		{
			name: 'leftToRight',
			value: 'leftToRight',
		},
	],
	renderingStrategy: [
		{
			name: 'lazy',
			value: 'lazy',
		},
		{
			name: 'eager',
			value: 'eager',
		},
	],
	criteria: [
		{
			name: 'label',
			value: 'label',
		},
		{
			name: 'index',
			value: 'index',
		},
	],
	labelMatchCriteria: [
		{
			name: 'exact',
			value: 'exact',
		},
		{
			name: 'label',
			value: 'label',
		},
		{
			name: 'contains',
			value: 'contains',
		},
	],
	tag: [
		{
			name: 'h1',
			value: 'h1',
		},
		{
			name: 'h2',
			value: 'h2',
		},
		{
			name: 'h3',
			value: 'h3',
		},
		{
			name: 'div',
			value: 'div',
		},
	],
	orderBy: [
		{
			name: 'OrderByTopSaleDESC',
			value: 'OrderByTopSaleDESC',
		},
		{
			name: 'OrderByReleaseDateDESC',
			value: 'OrderByReleaseDateDESC',
		},
		{
			name: 'OrderByBestDiscountDESC',
			value: 'OrderByBestDiscountDESC',
		},
		{
			name: 'OrderByPriceDESC',
			value: 'OrderByPriceDESC',
		},
		{
			name: 'OrderByPriceASC',
			value: 'OrderByPriceASC',
		},
		{
			name: 'OrderByNameASC',
			value: 'OrderByNameASC',
		},
		{
			name: 'OrderByNameDESC',
			value: 'OrderByNameDESC',
		},
	],
	skuFilter: [
		{
			name: 'FIRST_AVAILABLE',
			value: 'FIRST_AVAILABLE',
		},
		{
			name: 'ALL_AVAILABLE',
			value: 'ALL_AVAILABLE',
		},
		{
			name: 'ALL',
			value: 'ALL',
		},
	],
	installmentCriteria: [
		{
			name: 'MAX_WITHOUT_INTEREST',
			value: 'MAX_WITHOUT_INTEREST',
		},
		{
			name: 'MAX_WITH_INTEREST',
			value: 'MAX_WITH_INTEREST',
		},
	],
	preferredSKU: [
		{
			name: 'FIRST_AVAILABLE',
			value: 'FIRST_AVAILABLE',
		},
		{
			name: 'LAST_AVAILABLE',
			value: 'LAST_AVAILABLE',
		},
		{
			name: 'PRICE_ASC',
			value: 'PRICE_ASC',
		},
		{
			name: 'PRICE_DESC',
			value: 'PRICE_DESC',
		},
	],
	recommendation: [
		{
			name: 'similars',
			value: 'similars',
		},
		{
			name: 'suggestions',
			value: 'suggestions',
		},
		{
			name: 'accessories',
			value: 'accessories',
		},
		{
			name: 'view',
			value: 'view',
		},
		{
			name: 'buy',
			value: 'buy',
		},
		{
			name: 'viewandBought',
			value: 'viewandBought',
		},
	],
	showNavigationArrows: [
		{
			name: 'mobileOnly',
			value: 'mobileOnly',
		},
		{
			name: 'desktopOnly',
			value: 'desktopOnly',
		},
		{
			name: 'always',
			value: 'always',
		},
		{
			name: 'never',
			value: 'never',
		},
	],
	showPaginationDots: [
		{
			name: 'mobileOnly',
			value: 'mobileOnly',
		},
		{
			name: 'desktopOnly',
			value: 'desktopOnly',
		},
		{
			name: 'always',
			value: 'always',
		},
		{
			name: 'never',
			value: 'never',
		},
	],
	centerMode: [
		{
			name: 'disabled',
			value: 'disabled',
		},
		{
			name: 'center',
			value: 'center',
		},
		{
			name: 'to-the-left',
			value: 'to-the-left',
		},
	],
	initialSelection: [
		{
			name: 'complete',
			value: 'complete',
		},
		{
			name: 'image',
			value: 'image',
		},
		{
			name: 'empty',
			value: 'empty',
		},
	],
	showValueForVariation: [
		{
			name: 'none',
			value: 'none',
		},
		{
			name: 'image',
			value: 'image',
		},
		{
			name: 'all',
			value: 'all',
		},
	],
	showVariationsLabels: [
		{
			name: 'none',
			value: 'none',
		},
		{
			name: 'variation',
			value: 'variation',
		},
		{
			name: 'itemValue',
			value: 'itemValue',
		},
		{
			name: 'variationsAndItemValue',
			value: 'variationsAndItemValue',
		},
	],
	visibility: [
		{
			name: 'always',
			value: 'always',
		},
		{
			name: 'more-than-one',
			value: 'more-than-one',
		},
	],
	installmentsCriteria: [
		{
			name: 'max-quantity',
			value: 'max-quantity',
		},
		{
			name: 'max-quantity-without-interest',
			value: 'max-quantity-without-interest',
		},
	],
	callToActionMode: [
		{
			name: 'Nenhum',
			value: 'none',
		},
		{
			name: 'Button',
			value: 'button',
		},
		{
			name: 'Link',
			value: 'link',
		},
	],
	scroll: [
		{
			name: 'Content',
			value: 'content',
		},
		{
			name: 'Body',
			value: 'body',
		},
	],
	backdrop: [
		{
			name: 'Clicável',
			value: 'clickable',
		},
		{
			name: 'Nenhum',
			value: 'none',
		},
	],
	trigger: [
		{
			name: 'No Clique',
			value: 'click',
		},
		{
			name: 'Sempre',
			value: 'load',
		},
		{
			name: 'Uma vez por sessão',
			value: 'load session',
		},
	],
	maxVisible: [
		{ name: 'one', value: 'one' },
		{ name: 'many', value: 'many' },
	],
	navigationStep: [
		{ name: 'Page', value: 'page' },
		{ name: '1', value: '1' },
		{ name: '2', value: '2' },
		{ name: '3', value: '3' },
		{ name: '4', value: '4' },
		{ name: '5', value: '5' },
		{ name: '6', value: '6' },
		{ name: '7', value: '7' },
		{ name: '8', value: '8' },
	],
	horizontalAlign: [
		{ name: 'Esquerda', value: 'left' },
		{ name: 'Centro', value: 'center' },
		{ name: 'Direita', value: 'right' },
		{ name: 'Between', value: 'between' },
		{ name: 'Around', value: 'around' },
	],
	controlsType: [
		{ name: 'Native', value: 'native' },
		{ name: 'None', value: 'none' },
		{ name: 'Custom Vtex', value: 'custom-vtex' },
	],
	'FlexLayoutCol/horizontalAlign': [
		{ name: 'Esquerda', value: 'left' },
		{ name: 'Centro', value: 'center' },
		{ name: 'Direita', value: 'right' },
	],
	'ProductImages/displayMode': [
		{ name: 'Carousel', value: 'carousel' },
		{ name: 'List', value: 'list' },
		{ name: 'First Image', value: 'first-image' },
	],
	'Link/displayMode': [
		{ name: 'anchor ', value: 'anchor' },
		{ name: 'button', value: 'button' },
	],
	verticalAlign: [
		{ name: 'Top', value: 'top' },
		{ name: 'Middle', value: 'middle' },
		{ name: 'Bottom', value: 'bottom' },
	],
	'OverlayTrigger/trigger': [
		{ name: 'Click', value: 'click' },
		{ name: 'Hover', value: 'hover' },
	],
	'OverlayLayout/backdrop': [
		{ name: 'Visível', value: 'visible' },
		{ name: 'Sem Backdrop', value: 'none' },
	],
	'MenuItem/type': [
		{
			name: 'category',
			value: 'category',
		},
		{
			name: 'custom',
			value: 'custom',
		},
	],
};

export const getDropDownValues = ({ propName, componentName, objectName }) => {
	if (dropdownValues[`${componentName}/${objectName}/${propName}`])
		return dropdownValues[`${componentName}/${objectName}/${propName}`];
	if (dropdownValues[`${componentName}/${objectName ?? propName}`])
		return dropdownValues[`${componentName}/${objectName ?? propName}`];
	return dropdownValues[objectName ?? propName];
};

const EditorDropDown = ({
	propName,
	tooltip,
	componentName,
	title,
	propValue,
	values,
	componentId,
	arrayIndex,
	originalPropname,
}) => {
	const [options, setOptions] = React.useState({ title, values });
	const selectedPageValue = useSelector(selectedPage);
	const dispatch = useDispatch();
	const selectedComponentValue = useSelector(selectedComponent);
	const debounceFn = useCallback(_.debounce(handlePagesUpdate, 0), [
		selectedPageValue,
		componentId,
		selectedComponentValue,
	]);
	const [inputValue, setInputValue] = React.useState(propValue);

	React.useEffect(() => {
		setInputValue(propValue || '');
	}, [componentId]);

	function handlePagesUpdate(value) {
		const newSelectedComponent = JSON.parse(JSON.stringify(selectedComponentValue));
		let { comp } = findCompByIdRecursively([newSelectedComponent?.props], componentId);

		if (typeof comp.props[propName] === 'object') {
			comp.props[propName][title] = value;
		} else if (originalPropname) {
			if (typeof comp.props[originalPropname][arrayIndex][propName] === 'object') {
				comp.props[originalPropname][arrayIndex][propName][title] = value;
			} else {
				comp.props[originalPropname][arrayIndex][propName] = value;
			}
		} else {
			comp.props[propName] = value;
		}
		comp = checkIfNeedToChangeComponent(comp);
		dispatch(
			updateComponent({
				component: comp,
				componentId,
				pageId: selectedPageValue,
			}),
		);

		if (newSelectedComponent?.childComp) {
			const { comp: originalComp } = findCompByIdRecursively([newSelectedComponent?.props], componentId);
			originalComp.props = JSON.parse(JSON.stringify(comp.props));
		}

		//precisa disso pro componente renderizar corretamente se alterar + de 1 prop
		console.log(newSelectedComponent);
		dispatch(selectComponent(newSelectedComponent));
	}

	function handleChange(e) {
		const value = e.target.value;
		setInputValue(value);
		debounceFn(value);
	}

	function checkIfNeedToChangeComponent(comp) {
		const validationArr = [
			{
				componentName: 'MenuItem',
				path: 'props.type',
				action: {
					custom: { replacePath: 'props.itemProps', replaceWith: defaultCustom },
					category: { replacePath: 'props.itemProps', replaceWith: defaultCategory },
				},
			},
		];
		validationArr.forEach((validator) => {
			if (
				_.get(comp, validator.path) &&
				validator.action[_.get(comp, validator.path)] &&
				comp.componentName === validator.componentName
			) {
				_.set(
					comp,
					validator.action[_.get(comp, validator.path)].replacePath,
					validator.action[_.get(comp, validator.path)].replaceWith,
				);
			}
		});
		return comp;
	}

	return (
		<Flex className="mz-hef-edit" flex={'1 1 49%'} maxW={'49%'} flexDir="column">
			<label
				className="mz-hef-edit-label"
				mr={0}
				borderColor={'gray.200'}
				fontFamily={'Poppins'}
				color={'gray.700'}
				fontWeight="bold"
				fontSize={'sm'}
			>
				{options.title}
			</label>
			<select value={inputValue} onChange={(e) => handleChange(e)}>
				{options?.values?.map((el, i) => {
					return (
						<option key={i} value={el.value}>
							{el.name}
						</option>
					);
				})}
			</select>
		</Flex>
	);
};

export default EditorDropDown;
